import {Component, Inject, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { catchError, Observable, throwError } from 'rxjs';
import { CreateSeasonModel } from 'src/app/models/create-season-model';
import { SeasonFarmFieldModel } from 'src/app/models/season-farm-field-model';
import { SeasonFieldModel } from 'src/app/models/season-field-model';
import { SeasonTypeModel } from 'src/app/models/season-models/season-field-type-model';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';
import { SeasonSharedDataService } from 'src/app/services/season-shared-data.service';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
    selector: 'app-batch-select-fields',
    templateUrl: './batch-select-fields.component.html',
    styleUrls: ['./batch-select-fields.component.css'],
    standalone: false
})
export class BatchSelectFieldsComponent implements OnInit {

  selectBatchFieldsForm: FormGroup;
  filterForm: FormGroup;

  tenantId: string = null;
  seasonId: number = null;
  farmId: number = null;
  fieldId: number = null;

  isFarmSelected: boolean = false;
  isFieldSelected: boolean = false;

  //  farms: SeasonFarmFieldModel[];
  season: CreateSeasonModel = null;
  selectedType: SeasonTypeModel = null;
  // type: string = null;

  field: any = null;
  farms: any = [];
  filteredFarms: any = [];
  selectedFields: any = [];
  types: SeasonTypeModel[] = [];
  typeAll: SeasonTypeModel = null;
  fieldType: SeasonTypeModel = null;
  filterTypes: SeasonTypeModel[] = [];
  selectedFarmsToAddToSeason = [];
  selectedFieldsToAddToSeason = [];

  placeholder: string = '-';


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public batchSelectFieldsComponent: MatDialogRef<BatchSelectFieldsComponent>,
    public batchSelectFieldsCloseDialog: MatDialog,
    public nav: NavBarComponent,
    private fb: FormBuilder,
    private seasonManagerService: SeasonManagerService,
    private tenantService: TenantService,
    private seasonSharedDataService: SeasonSharedDataService,

  ) {

    batchSelectFieldsComponent.disableClose = true;

  }



  ngOnInit(): void {
    this.setMetaData();
    this.seasonId = this.data.seasonId;
    this.populateSelectableFarmAndFieldDetails();
  }


  toggleAllFarmFieldsSelection(event: any, farmIndex: number): void {
    this.filteredFarms[farmIndex].isSelected = event.checked;
    this.filteredFarms[farmIndex].isTouched = false;
    this.filteredFarms[farmIndex]?.fields?.forEach(field => {
      field.isChecked = event.checked;

      let index = this.selectedFields.findIndex(f => f.id === field.id)
      if(event.checked) {
        if(index === -1) {
          this.selectedFields.push(field);
        }
      } else {
        this.selectedFields.splice(index, 1);
      }
    });
  }


  onFieldSelectedChecked(event: any, farmIndex: number, fieldIndex: number) {
    this.filteredFarms[farmIndex].fields[fieldIndex].isChecked = event.checked;

    if(event.checked) {
      this.selectedFields.push(this.filteredFarms[farmIndex].fields[fieldIndex]);
    } else {
      let index = this.selectedFields.findIndex(f => f.id === this.filteredFarms[farmIndex].fields[fieldIndex].id)
      this.selectedFields.splice(index, 1);
    }

    let allIsSelected = this.filteredFarms[farmIndex].fields.every(field => field.isChecked);
    this.filteredFarms[farmIndex].isSelected = allIsSelected;

    if(!allIsSelected) {
      this.filteredFarms[farmIndex].isTouched = this.filteredFarms[farmIndex].fields.some(field => field.isChecked);
    } else {
      this.filteredFarms[farmIndex].isTouched = false;
    }
  }

  onFarmSelectedChecked(event: any, id: number) {
    if (event.checked) {
      // Add to the array if checked
      this.selectedFarmsToAddToSeason.push(id);
    } else {
      // Remove from the array if unchecked
      const index = this.selectedFarmsToAddToSeason.indexOf(id);
      if (index > -1) {
        this.selectedFarmsToAddToSeason.splice(index, 1);
      }
    }
  }


  populateFieldType() {
    for (let type of this.filterTypes) {
      if (this.field?.fieldType?.id === type.id) {
        this.field.fieldType = type;
        break;
      }
    }

  }

  setMetaData() {

    this.types = null;

    this.filterTypes = null;

    this.seasonSharedDataService.typeData$.subscribe(data => {

      this.types = data;
    });

    this.filterTypes = [...this.types];

    if (this.filterTypes[0].description !== 'All') {
      this.typeAll = {
        id: 0,
        description: 'All',
        detailTableName: null,
        active: null,
        creationDate: null,
        dateModified: null
      }
      this.filterTypes.unshift(this.typeAll);
    }
    this.selectedType = this.filterTypes[0];

  }


  populateSelectableFarmAndFieldDetails() {
    this.nav.toggleLoading(true);
    this.seasonManagerService.getSeasonById(this.seasonId).pipe(
      catchError(error => {
        console.error();
        this.nav.toggleLoading(false);
        return throwError(() => error);
      })
    ).subscribe((response) => {

      this.nav.toggleLoading(false);
      if(this.selectedType?.id !== 0) {
        response = response.filter(farm => farm.fields.some(field => field.fieldType === this.selectedType?.id)).map(farm => ({
          ...farm,
          fields: farm.fields.filter(field => field?.fieldType === this.selectedType?.id)
        }));
      }
      this.filteredFarms = [...response];

      for(let farmIndex = 0; farmIndex < this.filteredFarms.length; farmIndex++) {
        let selectCount = 0;
        for(let fieldIndex = 0; fieldIndex < this.filteredFarms[farmIndex].fields.length; fieldIndex++) {
          this.filteredFarms[farmIndex].fields[fieldIndex].description = this.types.find(t => t.id === this.filteredFarms[farmIndex].fields[fieldIndex].fieldType)?.description;
          if(this.selectedFields.some(s => s.id === this.filteredFarms[farmIndex].fields[fieldIndex].id)) {
            this.filteredFarms[farmIndex].fields[fieldIndex].isChecked = true;
            selectCount++;
          } else {
            this.filteredFarms[farmIndex].fields[fieldIndex].isChecked = false;
          }
        }
        if(selectCount === this.filteredFarms[farmIndex].fields.length) {
          this.filteredFarms[farmIndex].isSelected = true;
        } else {
          if(selectCount > 0) {
            this.filteredFarms[farmIndex].isSelected = false;
            this.filteredFarms[farmIndex].isTouched = true;
          }
        }
      }
    });
  }

  addFields() {
    this.batchSelectFieldsComponent.close({ "selectedFields": this.selectedFields });
  }

  close(): void {
    this.batchSelectFieldsComponent.close();
  }
}